module.exports = __webpack_public_path__ + "static/media/freshcaller-logo.b1a74968.svg";